export default __webpack_public_path__ + "static/media/cash.363d84ec.svg";